module.exports = __webpack_public_path__ + "static/hover-bg-1b2da6fab5a203416377060832365a6a.png";